import { render, staticRenderFns } from "./MessageDlg.vue?vue&type=template&id=45463814"
import script from "./MessageDlg.vue?vue&type=script&lang=js"
export * from "./MessageDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports